// Legacy order URLs carry a cosmetic status slug after the order number, e.g.
// /lt/paskyra/uzsakymai/LT202607010115/neapmoketa/#payment. That segment is
// emitted by the Neopay payment-return redirect on cancel/fail/bad-signature
// and has no backend meaning (the order-detail route reads only the number).
// Our order-detail route matches a single [slug] segment, so these URLs fall
// through to the CMS catch-all and 404. Detect them and 301 to the canonical
// order URL, preserving the #payment hash so the payment section can be focused.
export default defineNuxtRouteMiddleware((to) => {
  const isOrderDetail = (name: unknown): name is string =>
    typeof name === 'string' && name.startsWith('account-orders-slug')

  // Already a valid order-detail route: nothing to strip.
  if (isOrderDetail(to.name)) return

  const segments = to.path.replace(/\/+$/, '').split('/').filter(Boolean)
  // Need at least /{locale}/{...base}/{number}/{slug}
  if (segments.length < 4) return

  const parentPath = '/' + segments.slice(0, -1).join('/') + '/'
  const resolved = useRouter().resolve(parentPath)

  if (isOrderDetail(resolved.name)) {
    return navigateTo({ path: parentPath, query: to.query, hash: to.hash }, { redirectCode: 301 })
  }
})
